document.addEventListener('DOMContentLoaded', () => {
  /**
   * FAQ section toggle logic:
   * This logic toggles the answer sections for each faq-element.
   */
  const collapseContainerEls = document.querySelectorAll('.faq-list');
  // Instantiate this logic for each collapse container
  collapseContainerEls.forEach(collapseContainer => {
    let currentlySelectedEntry;
    const answerEls = collapseContainer.querySelectorAll('.faq-entry .answer');
    const questionEls = collapseContainer.querySelectorAll('.faq-entry .question');
    const faqEntries = collapseContainer.querySelectorAll('.faq-entry');

    /**
     * Selects a faq element, closes all other elements.
     *
     * @param {number} id - Id of the question-answer block that should be active
     */
    function selectFAQEntry(id) {
      faqEntries.forEach((entry, i) => {
        const question = Array.from(questionEls)[i];
        const answer = Array.from(answerEls)[i];
        if (+entry.dataset.id === id && !entry.classList.contains('active')) {
          // Show this one
          entry.style.maxHeight = `${getElementHeight(question) + getElementHeight(answer)}px`;
          entry.classList.add('active');
        } else {
          // Hide this one
          entry.style.maxHeight = `${getElementHeight(question)}px`;
          entry.classList.remove('active');
        }
        currentlySelectedEntry = id;
      });
    }

    /**
     * Gets the absolute height of an element, including their margin.
     *
     * @param {HTMLElement} el - Element we want to know the height of
     */
    function getElementHeight(el) {
      const style = window.getComputedStyle(el);
      const margin = parseInt(style['marginTop']) + parseInt(style['marginBottom']);
      return Math.ceil(el.offsetHeight + margin);
    }

    // Select first question on init
    window.requestAnimationFrame(() => selectFAQEntry(0));

    // Automatically run max-height setting on window-resize
    let timeout;
    window.addEventListener('resize', () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => selectFAQEntry(currentlySelectedEntry), 250);
    });

    // Toggle answers on-click
    faqEntries.forEach(faqEntry => faqEntry.addEventListener('click', () => selectFAQEntry(+faqEntry.dataset.id)));
  });
});
